var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { withTheme } from 'styled-components';
import SvgLoading from '../Icon/SvgLoading';
const Button = (props) => {
    const { children, theme, _variant: variant, special, size, fullWidth, color, darkMode: darkModeProp, loading, disabled, compact, onClick, className, forwardedRef, top, right, bottom, left, _BtnComp: BtnComp } = props, others = __rest(props, ["children", "theme", "_variant", "special", "size", "fullWidth", "color", "darkMode", "loading", "disabled", "compact", "onClick", "className", "forwardedRef", "top", "right", "bottom", "left", "_BtnComp"]);
    const btnRef = forwardedRef || React.createRef();
    const doesBtnContainIconOnly = React.useMemo(() => variant === 'icon-only' || variant === 'fab-icon', [variant]);
    const isBtnForDarkMode = React.useMemo(() => darkModeProp && (variant === 'contained' || variant === 'outlined'), [darkModeProp, variant]);
    const resolvedClassNames = React.useMemo(() => clsx({
        '_ndsBtn--large': size === 'l' || special === 'price',
        '_ndsBtn--medium': size === 'm' && !doesBtnContainIconOnly,
        '_ndsBtn--fluid': fullWidth,
        '_ndsBtn--compact': compact,
        '_ndsBtn--icon': doesBtnContainIconOnly,
        '_ndsBtn--destructive': color === 'destructive' && !darkModeProp,
        '_ndsBtn--grey': color === 'grey' && !darkModeProp,
        '_ndsBtn--loading': loading && !disabled,
        '_ndsBtn--price': special === 'price',
        '_ndsBtn--dark-mode': isBtnForDarkMode
    }, className), [
        size,
        fullWidth,
        doesBtnContainIconOnly,
        color,
        loading,
        disabled,
        special,
        className,
        compact,
        darkModeProp,
        isBtnForDarkMode
    ]);
    const loadingIconAttrs = React.useMemo(() => {
        let iconColor = theme.ColorIconButtonDefaultBase;
        if (color === 'grey') {
            iconColor = theme.ColorIconButtonDefaultGrey;
        }
        if (color === 'destructive') {
            iconColor = theme.ColorIconButtonDefaultError;
        }
        switch (variant) {
            case 'contained':
                if (isBtnForDarkMode) {
                    iconColor = theme.ColorFontButtonContainedDarkBase;
                }
                else {
                    iconColor =
                        color === 'grey' ? theme.ColorIconButtonContainedGrey : theme.ColorFontWhite;
                }
                break;
            case 'fab':
            case 'fab-icon':
                iconColor =
                    color === 'grey' ? theme.ColorIconButtonContainedGrey : theme.ColorFontWhite;
                break;
            case 'outlined':
                if (isBtnForDarkMode) {
                    iconColor = theme.ColorFontButtonOutlinedDarkBase;
                }
                break;
            default:
        }
        if (special === 'price') {
            iconColor = theme.ColorIconButtonDefaultPrice;
        }
        return {
            color: iconColor
        };
    }, [theme, color, variant, special, isBtnForDarkMode]);
    const handleOnClick = React.useCallback((event) => {
        if (onClick != undefined && !disabled) {
            onClick(event);
        }
    }, [onClick, disabled]);
    const handleOnMouseUp = React.useCallback(() => {
        if (btnRef.current) {
            btnRef.current.blur();
        }
    }, [btnRef]);
    const prepareButtonContent = () => {
        let content;
        if (loading) {
            let loadingAnimatedIconSize = 's';
            if (doesBtnContainIconOnly) {
                loadingAnimatedIconSize = size === 'l' ? 'l' : 'm';
            }
            else if (size === 'm' || size === 'l' || special === 'price') {
                loadingAnimatedIconSize = 'm';
            }
            content = [
                React.createElement("div", { key: 1, className: "icon" },
                    React.createElement(SvgLoading, Object.assign({ size: loadingAnimatedIconSize }, loadingIconAttrs))),
                doesBtnContainIconOnly ? null : 'Loading...'
            ];
        }
        if (disabled) {
            content = children;
        }
        return content;
    };
    const buttonContent = prepareButtonContent() || children;
    return (React.createElement(BtnComp, Object.assign({ ref: btnRef, onMouseUp: handleOnMouseUp, onClick: handleOnClick }, ((disabled || loading) && { disabled: true }), { className: resolvedClassNames, color: color, top: top, right: right, bottom: bottom, left: left }, others), buttonContent));
};
Button.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    _variant: PropTypes.oneOf(['outlined', 'contained', 'icon-only', 'fab', 'fab-icon']),
    special: PropTypes.oneOf(['price']),
    size: PropTypes.oneOf(['s', 'm', 'l']),
    color: PropTypes.oneOf(['destructive', 'grey']),
    darkMode: PropTypes.bool,
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    compact: PropTypes.bool,
    fullWidth: PropTypes.bool,
    onClick: PropTypes.func,
    className: PropTypes.string,
    top: PropTypes.string,
    right: PropTypes.string,
    bottom: PropTypes.string,
    left: PropTypes.string,
    forwardedRef: PropTypes.any,
    theme: PropTypes.any,
    _BtnComp: PropTypes.any
};
Button.defaultProps = {
    children: null,
    _variant: undefined,
    special: undefined,
    size: 's',
    color: undefined,
    darkMode: false,
    loading: false,
    disabled: false,
    compact: false,
    fullWidth: false,
    onClick: null,
    className: undefined,
    top: undefined,
    right: undefined,
    bottom: undefined,
    left: undefined,
    forwardedRef: null,
    theme: {},
    _BtnComp: null
};
export { Button as ButtonRootComp };
export default withTheme(Button);
//# sourceMappingURL=Button.js.map